import { render, staticRenderFns } from "./Backtop.vue?vue&type=template&id=5b52233f&scoped=true&"
import script from "./Backtop.vue?vue&type=script&lang=js&"
export * from "./Backtop.vue?vue&type=script&lang=js&"
import style0 from "./Backtop.vue?vue&type=style&index=0&id=5b52233f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b52233f",
  null
  
)

export default component.exports